module.exports = __webpack_public_path__ + "img/delta_to_delta_trafo.4b4de47f.svg";